export function get<ReturnType = unknown>(key: string): ReturnType | null {
  const value = localStorage.getItem(key);

  try {
    if (value) {
      return JSON.parse(value);
    }
  } catch {
    // fallback to the previous value
    return value as unknown as ReturnType;
  }

  return null;
}

export function set<SetType>(key: string, value: SetType): void {
  localStorage.setItem(key, JSON.stringify(value));
}

export function remove(key: string): void {
  localStorage.removeItem(key);
}

export function clear(): void {
  localStorage.clear();
}
